// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__hdcij","description":"PatientConsentPreview_description__3Tdka"};